export default __webpack_public_path__ + "static/media/contactUs.2f145b2d.jpg";